(function () {
  const SPRAY_MAP = {
    '3ml': '40 a 45 borrifadas',
    '5ml': '60 a 65 borrifadas',
    '8ml': '105 a 110 borrifadas',
    '10ml': '135 a 140 borrifadas',
    '15ml': '185 a 190 borrifadas',
  };

  const VOLUMES = Object.keys(SPRAY_MAP);
  let frameScheduled = false;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace('ml.', 'ml');
  }

  function extractVolume(value) {
    const normalized = normalize(value);
    if (VOLUMES.includes(normalized)) return normalized;

    const match = normalized.match(/(?:^|[^0-9])(3|5|8|10|15)ml(?:$|[^a-z0-9])/i);
    return match ? `${match[1]}ml` : '';
  }

  function findRelatedPicker(box) {
    if (!box) return null;

    const scope =
      box.closest('quick-add-dialog') ||
      box.closest('.quick-add-modal') ||
      box.closest('.quick-add-modal__content') ||
      box.closest('.product-details') ||
      box.closest('[data-product-grid-content]') ||
      box.closest('[data-testid="product-information"]') ||
      box.parentElement;

    return (
      scope?.querySelector?.('variant-picker') ||
      box.previousElementSibling?.matches?.('variant-picker') && box.previousElementSibling ||
      null
    );
  }

  function getPickerVolume(picker) {
    if (!picker) return '';

    const checkedInputs = Array.from(picker.querySelectorAll('input[type="radio"]:checked'));
    for (const input of checkedInputs) {
      const volume = extractVolume(input.value || input.getAttribute('aria-label') || input.dataset.optionValue);
      if (volume) return volume;
    }

    const activeLabels = Array.from(picker.querySelectorAll('label:has(input[type="radio"]:checked), [aria-pressed="true"], .selected'));
    for (const label of activeLabels) {
      const volume = extractVolume(label.textContent || label.getAttribute('aria-label'));
      if (volume) return volume;
    }

    const selects = Array.from(picker.querySelectorAll('select'));
    for (const select of selects) {
      const selectedOption = select.options[select.selectedIndex];
      const volume = extractVolume(selectedOption?.value || selectedOption?.textContent || select.value);
      if (volume) return volume;
    }

    return '';
  }

  function updateBox(box) {
    if (!box) return;

    const picker = findRelatedPicker(box);
    const selectedVolume = getPickerVolume(picker) || extractVolume(box.dataset.currentVolume) || '3ml';
    const sprayCount = SPRAY_MAP[selectedVolume] || SPRAY_MAP['3ml'];

    if (box.dataset.renderedVolume === selectedVolume && box.dataset.renderedSprayCount === sprayCount) {
      return;
    }

    box.hidden = false;
    box.dataset.currentVolume = selectedVolume;
    box.dataset.renderedVolume = selectedVolume;
    box.dataset.renderedSprayCount = sprayCount;

    const titleEl = box.querySelector('.frenesi-spray-yield__title');
    if (titleEl && titleEl.textContent.trim() !== 'Rendimento aproximado') {
      titleEl.textContent = 'Rendimento aproximado';
    }

    const volumeEl = box.querySelector('[data-spray-volume]');
    if (volumeEl && volumeEl.textContent !== selectedVolume) {
      volumeEl.textContent = selectedVolume;
    }

    const countEl = box.querySelector('[data-spray-count]');
    if (countEl && countEl.textContent !== sprayCount) {
      countEl.textContent = sprayCount;
    }

  }

  function updateAll() {
    document.querySelectorAll('[data-frenesi-spray-yield]').forEach(updateBox);
  }

  function scheduleUpdate(delay) {
    const run = function () {
      if (frameScheduled) return;

      frameScheduled = true;
      window.requestAnimationFrame(function () {
        frameScheduled = false;
        updateAll();
      });
    };

    if (delay) {
      window.setTimeout(run, delay);
    } else {
      run();
    }
  }

  function scheduleVariantUpdate() {
    scheduleUpdate(0);
    scheduleUpdate(80);
    scheduleUpdate(220);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleUpdate(0);
  });

  window.addEventListener('pageshow', function () {
    scheduleUpdate(0);
  });

  document.addEventListener('shopify:section:load', function () {
    scheduleUpdate(0);
  });

  document.addEventListener('frenesi:spray-yield:update', function () {
    scheduleVariantUpdate();
  });

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest) return;

    if (
      event.target.closest('variant-picker') ||
      event.target.closest('quick-add-dialog') ||
      event.target.closest('[data-testid="product-information"]')
    ) {
      scheduleVariantUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    if (event.target.closest('variant-picker')) {
      scheduleVariantUpdate();
      return;
    }

    if (event.target.closest('quick-add-component')) {
      scheduleUpdate(250);
      scheduleUpdate(700);
    }
  });

  document.addEventListener('variant:update', function () {
    scheduleVariantUpdate();
  });
})();
